import { useEffect, FC } from 'react'
import { useToasts } from 'components/notifications/ToastProvider'

import useReduxSelector from 'hooks/useReduxSelector'
import withRenderClientsideOnly from 'components/utils/withRenderClientsideOnly'

const EmailUnverified: FC = () => {
  const { addToast } = useToasts()

  const emailAddress = useReduxSelector(
    (state) => state?.auth?.currentUser?.email,
  )
  const emailVerified = useReduxSelector(
    (state) => state?.auth?.currentUser?.email_verified,
  )

  useEffect(() => {
    if (emailAddress && emailVerified === false) {
      addToast(
        `Please confirm your email to finish signing up. Instructions were sent to ${emailAddress}. <a href="/resend-confirmation">Resend email.</a>`,
        {
          appearance: 'warning',
          autoDismiss: false,
        },
      )
    }
  }, [emailAddress && emailVerified])

  return null
}

export default withRenderClientsideOnly(EmailUnverified)
